import type { PartnerBrandingType } from '@poppy/firebase';

// White-label partners: resellers whose customers use Poppy under the partner's brand.
// Each partner lives at `partners/{slug}` and is served on `{slug}.getpoppy.ai`.

/** What the app needs to brand a page, as returned by GET /api/partners/[slug]. */
export type Partner = {
  slug: string;
  name: string;
  branding: PartnerBrandingType;
  // True only for the partner's owner, who may open the admin page.
  canEdit: boolean;
};

const PARTNER_SLUG = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

// Poppy's own subdomains are never partners.
const RESERVED_SUBDOMAINS = new Set([
  'app',
  'www',
  'admin',
  'api',
  'billing',
  'chatbot',
  'staging',
]);

export function isPartnerSlug(value: string): boolean {
  return PARTNER_SLUG.test(value) && !RESERVED_SUBDOMAINS.has(value);
}

/** `rootcauseclinic.getpoppy.ai` → `rootcauseclinic`; any other host → null. */
export function partnerSlugFromHost(hostname: string): string | null {
  const match = hostname.match(/^([^.]+)\.getpoppy\.ai$/);
  return match && isPartnerSlug(match[1]) ? match[1] : null;
}
